import { createRandomString } from '@pcg/text-kit';

export class InvalidTokenException extends Error {
  message = 'InvalidTokenException';
}

export interface JsonWebToken {
  uid: string;
  exp: string;
}

export const generateRequestId = () => {
  return `hcreq:${createRandomString(11)}`;
};

/**
 * Cookie names used for authentication
 */
export const COOKIE_NAMES = {
  session: 'tl_session',
  subscriptionToken: 'tl_subscription_token',
} as const;

/**
 * Read a cookie value by name
 */
export const getCookie = (name: string): string | null => {
  const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));

  return match?.[2] ? decodeURIComponent(match[2]) : null;
};

/**
 * Get subscription token from cookie (for WebSocket connections)
 * This cookie is NOT httpOnly so JS can access it
 */
export const getSubscriptionTokenFromCookie = (): string | null => {
  return getCookie(COOKIE_NAMES.subscriptionToken);
};

/**
 * Logout by calling the API to clear HTTP-only cookies
 */
export const logoutWithCookies = async (logoutUrl: string): Promise<void> => {
  await fetch(logoutUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-request-id': generateRequestId(),
    },
    credentials: 'include',
  });
};
